export const ID_NAVBAR_BOTTOM = 'navbar-bottom';
export const COMPONENT_BESTSELLER = 'bestseller';
export const COMPONENT_MAP = 'map';
export const COMPONENT_DESCRIPTION = 'description';
export const COMPONENT_DESCRIPTION_TWO = 'description_two';
export const COMPONENT_FEATURES = 'features';
export const COMPONENT_MOBILEAPP = 'mobileapp';
